import { TFunction } from '@mint-lib/i18n';

export const normalizeString = (value: string) => value.trim().toLowerCase();

export const getDateFormatLabel = (t: TFunction, dateFormatType: string) => {
  const dateLabelsByType: Record<string, string> = {
    D: t('Day'),
    M: t('Month'),
    Y: t('Year'),
  };

  const dateFormatLabel = Array.from(dateFormatType)
    .map((v) => dateLabelsByType[v])
    .join(' → ');

  return dateFormatLabel;
};
